import { useMemo } from "react";
import useResizeObserver from "./useResizeObserver";

function useRefSizeObserver(elementRef: HTMLElement | null = window.document.body) {
  const size = useResizeObserver(elementRef);

  const width = useMemo(() => size[0]?.contentRect.width ?? 0, [size]);

  return width;
}

export default useRefSizeObserver;
